<template>
  <div class="herbal-medicine-index">
    <div class="contain">
      <!-- 上方按钮 -->
      <el-row class="button-group">
        <el-button size="small" icon="el-icon-search" @click="searchB()" class="more-search-css"></el-button>
        <el-input placeholder="请输入关键字搜索" v-model="searchInput" class="search-input" v-show="showS" @input="keyWords(searchInput)"></el-input>
        <el-button size="small" @click="allData()" class="add-two-border" :class="all ? 'select-checked' : 'no-checked'">全部</el-button>
        <el-popover placement="bottom" trigger="click" v-model="visible1">
          <el-row class="child-button-group">
            <el-button size="small" v-for="(item, index) in effectList" :key="index" :class="item.checked ? 'select-checked' : 'no-checked'" @click="select(item, index, 1)">{{ item.name }}</el-button>
          </el-row>
          <el-button slot="reference" :class="one ? 'search-parent-selected' : 'no-checked'">
            药品功效
            <i class="el-icon-arrow-down"></i>
          </el-button>
        </el-popover>
        <el-popover placement="bottom" trigger="click" v-model="visible2">
          <el-row class="child-button-group">
            <el-button size="small" v-for="(item, index) in yaoxingList" :key="index" :class="item.checked ? 'select-checked' : 'no-checked'"
              @click="select(item, index, 2)">{{ item.name }}</el-button>
          </el-row>
          <el-button slot="reference" :class="two ? 'search-parent-selected' : 'no-checked'">
            药性
            <i class="el-icon-arrow-down"></i>
          </el-button>
        </el-popover>
        <el-popover placement="bottom" trigger="click" v-model="visible3">
          <el-row class="child-button-group">
            <el-button size="small" v-for="(item, index) in yaoweiList" :key="index" :class="item.checked ? 'select-checked' : 'no-checked'" @click="select(item, index, 3)">{{ item.name }}</el-button>
          </el-row>
          <el-button slot="reference" :class="three ? 'search-parent-selected' : 'no-checked'">
            药味
            <i class="el-icon-arrow-down"></i>
          </el-button>
        </el-popover>
        <el-popover placement="bottom" trigger="click" v-model="visible4">
          <el-row class="child-button-group">
            <el-button size="small" v-for="(item, index) in guijingList" :key="index" :class="item.checked ? 'select-checked' : 'no-checked'"
              @click="select(item, index, 4)">{{ item.name }}</el-button>
          </el-row>
          <el-button slot="reference" :class="four ? 'search-parent-selected' : 'no-checked'">
            归经
            <i class="el-icon-arrow-down"></i>
          </el-button>
        </el-popover>
        <el-popover placement="bottom" trigger="click" v-model="visible5">
          <el-row class="child-button-group">
            <el-button size="small" v-for="(item, index) in yaobuweiList" :key="index" :class="item.checked ? 'select-checked' : 'no-checked'"
              @click="select(item, index, 5)">{{ item.name }}</el-button>
          </el-row>
          <el-button slot="reference" :class="five ? 'search-parent-selected' : 'no-checked'">
            药用部位
            <i class="el-icon-arrow-down"></i>
          </el-button>
        </el-popover>
      </el-row>
      <el-row class="pinyin-btn-group row-bg" type="flex" justify="space-between">
        <el-button size="small" class="ZM" @click="resetZM()">按拼音检索</el-button>
        <el-button :class="item.checked ? 'ZM-selected' : 'ZM'" v-for="(item, index) in zimuList" :key="index" @click="select(item, index, 6)">{{ item.name }}</el-button>
      </el-row>
      <el-row class="tag-row my-tag zcy">
        已选择：
        <el-tag v-for="(item, index) in selectLabel" :key="index" :type="item.name" closable @close="e=>handleClose(e,item.name,item.id)">{{ item.name }}</el-tag>
      </el-row>

      <el-row :gutter="20" class="video-list">
        <el-col :span="6" v-for="(item, index) in zhongcaoyaoList" :key="index">
          <div @click="zhongcaoyaoD(item.id)" class="shou">
            <div class="img-outer">
              <!-- 轮播图 -->
              <el-carousel class="top-carousel top-carousel-box top-carousel-medicine">
                <el-carousel-item v-if="!item.photoUrl.length" class="carousel-img-outer common-img-outer">
                  <img src="../assets/img/suolue.jpg" alt/>
                </el-carousel-item>
                <el-carousel-item v-if="item.photoUrl.length" v-for="(items, indexs) in item.photoUrl" :key="indexs" class="carousel-img-outer common-img-outer">
                   <img :src="$store.state.imgUrl+items" alt/>
                </el-carousel-item>
              </el-carousel>
              <!-- <img :src="$store.state.imgUrl+item.photoUrl" style="width:100%" /> -->
            </div>
            <div class="forum-title text-center">{{ item.atName }}</div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-pagination background layout="prev, pager, next" :total="pageInfo.total" :page-size="pageInfo.pageSize" @current-change="handleCurrentChange"></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "HerbalMedicineIndex",
  data () {
    return {
      showS: false, //搜索框不显示
      // 全部与那五个的筛选条件是否选中开始
      all: true,
      one: false,
      two: false,
      three: false,
      four: false,
      five: false,
      // 全部与那五个的筛选条件是否选中结束
      // 五个筛选条件的弹框默认是否显示开始
      visible1: false,
      visible2: false,
      visible3: false,
      visible4: false,
      visible5: false,
      // 五个筛选条件的弹框默认是否显示结束
      zimuList: [
        {
          id:'zmA',
          name: "A",
          checked: false
        },
        {
          id:'zmB',
          name: "B",
          checked: false
        },
        {
          id:'zmC',
          name: "C",
          checked: false
        },
        {
          id:'zmD',
          name: "D",
          checked: false
        },
        {
          id:'zmE',
          name: "E",
          checked: false
        },
        {
          id:'zmF',
          name: "F",
          checked: false
        },
        {
          id:'zmG',
          name: "G",
          checked: false
        },
        {
          id:'zmH',
          name: "H",
          checked: false
        },
        {
          id:'zmI',
          name: "I",
          checked: false
        },
        {
          id:'zmJ',
          name: "J",
          checked: false
        },
        {
          id:'zmK',
          name: "K",
          checked: false
        },
        {
          id:'zmL',
          name: "L",
          checked: false
        },
        {
          id:'zmM',
          name: "M",
          checked: false
        },
        {
          id:'zmN',
          name: "N",
          checked: false
        },
        {
          id:'zmO',
          name: "O",
          checked: false
        },
        {
          id:'zmP',
          name: "P",
          checked: false
        },
        {
          id:'zmQ',
          name: "Q",
          checked: false
        },
        {
          id:'zmR',
          name: "R",
          checked: false
        },
        {
          id:'zmS',
          name: "S",
          checked: false
        },
        {
          id:'zmT',
          name: "T",
          checked: false
        },
        {
          id:'zmU',
          name: "U",
          checked: false
        },
        {
          id:'zmV',
          name: "V",
          checked: false
        },
        {
          id:'zmW',
          name: "W",
          checked: false
        },
        {
          id:'zmX',
          name: "X",
          checked: false
        },
        {
          id:'zmY',
          name: "Y",
          checked: false
        },
        {
          id:'zmZ',
          name: "Z",
          checked: false
        }
      ],
      // 7个选中的搜索条件开始
      searchInput: "", //文本框搜索内容
      ypgx: "",
      ypgxId:"",
      yw: "",
      ywId:"",
      yx: "",
      yxId:"",
      gj: "",
      gjId:"",
      yybw: "",
      yybwId: "",
      selectZM: "",
      selectZMId: "",
      // 7个选中的搜索条件结束
      zhongcaoyaoList: [], //中草药列表数据
      // dynamicTags: ["标签一", "标签二", "标签三"],
      selectLabel: [] //已选择的条件
    };
  },
  methods: {
    //删除已选的某个标签
    handleClose (e,tag,id) {
      let that = this;
      for (let i = 0; i < that.selectLabel.length; i++) {
        if (that.selectLabel[i].id === id) {
            that.selectLabel.splice(i, 1);
            i--; // 因为删除元素后，数组索引会改变，需要将索引回退一位，确保不漏查元素
        }
     }
      // that.selectLabel.splice(that.selectLabel.indexOf(tag), 1);
      that.effectList.findIndex(item => {
        if (item.id === id) {
          item.checked = false;
          that.one = false;
          that.ypgx = "";
          that.ypgxId = "";
          that.effectList[0].checked = true;
        }
      });
      that.yaoxingList.findIndex(item => {
        if (item.id === id) {
          item.checked = false;
          that.two = false;
          that.yx = "";
          that.yxId = "";
          that.yaoxingList[0].checked = true;
        }
      });
      that.yaoweiList.findIndex(item => {
        if (item.id === id) {
          item.checked = false;
          that.three = false;
          that.yw = "";
          that.ywId = "";
          that.yaoweiList[0].checked = true;
        }
      });

      that.guijingList.findIndex(item => {
        if (item.id === id) {
          item.checked = false;
          that.four = false;
          that.gj = "";
          that.gjId = "";
          that.guijingList[0].checked = true;
        }
      });

      that.yaobuweiList.findIndex(item => {
        if (item.id === id) {
          item.checked = false;
          that.five = false;
          that.yybw = "";
          that.yybwId = "";
          that.yaobuweiList[0].checked = true;
        }
      });
      that.zimuList.findIndex(item => {
        if (item.id === id) {
          item.checked = false;
          that.six = false;
          that.selectZM = "";
          that.selectZMId = "";
        }
      });

      that.getList(
        that.searchInput,
        that.ypgx,
        that.yx,
        that.yw,
        that.gj,
        that.yybw,
        that.selectZM
      );
    },
    //中草药详情
    zhongcaoyaoD (id) {
      this.$router.push({
        path: "/HerbalMedicineDetail",
        query: { id: id }
      });
    },
    //选页
    handleCurrentChange (v) {
      let that = this;
      // console.log(v);
      that.pageInfo.pageNum = v; //当前页

      that.getList(
        that.searchInput,
        that.ypgx,
        that.yx,
        that.yw,
        that.gj,
        that.yybw,
        that.selectZM,
        that.pageInfo.pageNum
      );
    },
    //搜索按钮
    searchB () {
      let that = this;
      if (that.showS) {
        that.showS = false;
      } else {
        that.showS = true;
      }
    },
    //全部
    allData () {
      let that = this;
      that.searchInput = that.ypgx = that.yx = that.yw = that.gj = that.yybw =
        "";
      that.selectLabel = [];
      that.all = true;
      that.one = that.two = that.three = that.four = that.five = false;
      for (let c of that.effectList) {
        c.checked = false;
      }
      that.effectList[0].checked = true;
      for (let c of that.yaoxingList) {
        c.checked = false;
      }
      that.yaoxingList[0].checked = true;
      for (let c of that.yaoweiList) {
        c.checked = false;
      }
      that.yaoweiList[0].checked = true;
      for (let c of that.guijingList) {
        c.checked = false;
      }
      that.guijingList[0].checked = true;
      for (let c of that.yaobuweiList) {
        c.checked = false;
      }
      that.yaobuweiList[0].checked = true;
      for (let c of that.zimuList) {
        c.checked = false;
      }
      that.getList();
    },
    //searchInput搜索框
    getList (searchInput, ypgx, yx, yw, gj, yybw, selectZM, pageNum) {
      let that = this;
      if (pageNum) {
        that.pageInfo.pageNum = pageNum;
      } else {
        that.pageInfo.pageNum = 1;
      }
      // console.log("文本框关键字:" + searchInput);
      // console.log("药品功效:" + ypgx);
      // console.log("药性:" + yx);
      // console.log("药味:" + yw);
      // console.log("归经:" + gj);
      // console.log("药用部位:" + yybw);
      // console.log("选择的字母:" + selectZM);
      // console.log("第几页:" + that.pageInfo.pageNum);

      let url = "/ypgl/getYpglList";
      let parmas = {
        atName: searchInput,
        pinyinName: selectZM,
        efficacyDrugs: ypgx,
        medicine: yx,
        pill: yw,
        channelTropism: gj,
        medicinalPart: yybw,
        pageNum: that.pageInfo.pageNum,
        pageSize: that.pageInfo.pageSize
      };
      that.$http
        .post(url, parmas)
        .then(res => {
          if (res.data.code == 200) {
            that.pageInfo.total = res.data.data.total;
            that.pageInfo.pageSize = res.data.data.pageSize;
            that.zhongcaoyaoList = [];
            that.zhongcaoyaoList = res.data.data.list.map((item, index) => {
              let urls = [];
              if (item.drugPhotoUrl) {
                let str = item.drugPhotoUrl;
                if (str[str.length - 1] === ',') {
                    str = str.slice(0, str.length - 1);
                }
                urls = str.split(",");
              } else {
                urls = [];
              }

              // if (urls.length > 1) {
              //   urls.pop();
              // }
              return {
                atName: item.atName,
                photoUrl: urls,
                id: item.id
              };
            });
          } else {
            that.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          that.$message.error("网络错误！");
        });
    },
    //searchInput搜索框
    keyWords (searchInput) {
      let that = this;
      // if (searchInput) {
      //     this.all = this.one = this.two = this.three = this.four = this.five = false;
      //     for (let c of that.effectList) {
      //         c.checked = false;
      //     }
      //     that.effectList[0].checked = true;
      //     for (let c of that.yaoxingList) {
      //         c.checked = false;
      //     }
      //     that.yaoxingList[0].checked = true;
      //     for (let c of that.yaoweiList) {
      //         c.checked = false;
      //     }
      //     that.yaoweiList[0].checked = true;
      //     for (let c of that.guijingList) {
      //         c.checked = false;
      //     }
      //     that.guijingList[0].checked = true;
      //     for (let c of that.yaobuweiList) {
      //         c.checked = false;
      //     }
      //     that.yaobuweiList[0].checked = true;
      // }

      that.getList(
        searchInput,
        that.ypgx,
        that.yx,
        that.yw,
        that.gj,
        that.yybw,
        that.selectZM
      );
    },
    //已选择的标签
    selectLableFunction () {
      let that = this;
      that.selectLabel = [];
      if (that.ypgx) {
        that.selectLabel.push({
          name: that.ypgx,
          id:that.ypgxId
        });
      }
      if (that.yx) {
        that.selectLabel.push({
          name: that.yx,
          id:that.yxId
        });
      }
      if (that.yw) {
        that.selectLabel.push({
          name: that.yw,
          id:that.ywId
        });
      }
      if (that.gj) {
        that.selectLabel.push({
          name: that.gj,
          id:that.gjId
        });
      }
      if (that.yybw) {
        that.selectLabel.push({
          name: that.yybw,
          id:that.yybwId
        });
      }
      if (that.selectZM) {
        that.selectLabel.push({
          name: that.selectZM,
          id:that.selectZMId
        });
      }
      // console.log(that.selectLabel,"that.selectLabel")
    },
    select (v, i, n) {
      // console.log('检索-v', v)
      // console.log('检索-i', i)
      // console.log('检索-n', n)
      let that = this;
      // console.log(v.id);
      // 药品功效

      if (n == 1) {
        for (let c of that.effectList) {
          c.checked = false;
        }
        v.checked = true;
        that.all = false;
        if (v.name != "不限") {
          that.one = true;
          that.ypgx = v.name;
          that.ypgxId = v.id;
        } else {
          that.one = false;
          that.ypgx = "";
          that.ypgxId = "";
        }
        that.visible1 = false;
      }

      //药性
      if (n == 2) {
        for (let c of that.yaoxingList) {
          c.checked = false;
        }
        v.checked = true;
        that.all = false;
        if (v.name != "不限") {
          that.two = true;
          that.yx = v.name;
          that.yxId = v.id;
        } else {
          that.two = false;
          that.yx = "";
          that.yxId = "";
        }
        that.visible2 = false;
      }
      //药味
      if (n == 3) {
        for (let c of that.yaoweiList) {
          c.checked = false;
        }
        v.checked = true;
        that.all = false;
        if (v.name != "不限") {
          that.three = true;
          that.yw = v.name;
          that.ywId = v.id;
        } else {
          that.three = false;
          that.yw = "";
          that.ywId = "";
        }
        that.visible3 = false;
      }
      //归经
      if (n == 4) {
        for (let c of that.guijingList) {
          c.checked = false;
        }
        v.checked = true;
        that.all = false;
        if (v.name != "不限") {
          that.four = true;
          that.gj = v.name;
          that.gjId = v.id;
        } else {
          that.four = false;
          that.gj = "";
          that.gjId = "";
        }
        that.visible4 = false;
      }
      //药用部位
      if (n == 5) {
        for (let c of that.yaobuweiList) {
          c.checked = false;
        }
        v.checked = true;
        that.all = false;
        if (v.name != "不限") {
          that.five = true;
          that.yybw = v.name;
          that.yybwId = v.id;
        } else {
          that.five = false;
          that.yybw = "";
          that.yybwId = "";
        }
        that.visible5 = false;
      }
      //字母
      if (n == 6) {
        // console.log('that.zimuList', that.zimuList)
        for (let c of that.zimuList) {
          c.checked = false;
        }
        v.checked = true;
        that.all = false;
        that.selectZM = v.name;
        that.selectZMId = v.id;
      }
      // else {
      //     for (let c of that.zimuList) {
      //         c.checked = false;
      //     }
      // }
      that.selectLableFunction();
      that.getList(
        that.searchInput,
        that.ypgx,
        that.yx,
        that.yw,
        that.gj,
        that.yybw,
        that.selectZM
      );
    },
    //重置字母
    resetZM () {
      let that = this;
      for (let c of that.zimuList) {
        c.checked = false;
      }
      that.selectZM = "";
      that.selectLableFunction();
      that.getList(
        that.searchInput,
        that.ypgx,
        that.yx,
        that.yw,
        that.gj,
        that.yybw,
        that.selectZM
      );
    }
  },
  created () {
    let that = this;
    that.getList();
    that.dataDictionary("medicine");
    that.dataDictionary("pill");
    that.dataDictionary("channelTropism");
    that.dataDictionary("medicinalPart");
    that.dataDictionary("efficacyDrugsDescribe");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.child-button-group{
		max-width: 450px!important;
   display: flex;
    flex-wrap:wrap;
    justify-content: space-around;/*  水平方向上的分布 */
    align-items: stretch; /* 垂直方向上的拉伸 */
	}
  .child-button-group .el-button:last-child {
     /* 让最后一个元素的右边距自动适应，从而实现左对齐的效果。*/
    margin-right: auto!important; 
}
  .select-checked{
    height: 33px;
  }
  .el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered{
    margin-left: 2px!important;
  }
.el-carousel img {
  width: 100%;
  /* height: 100%; */
}
.el-carousel--horizontal {
  width: 100%;
  height: 100%;
}
.img-outer {
  width: 241px;
  height: 136.13px;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.tag-row {
  text-align: left;
  margin: 20px auto;
  padding-left: 15px;
  color: #666666;
}

.button-group .el-button {
  padding: 9px 20px;
}

.button-group {
 text-align: left;
  padding: 20px 0px 10px;
}

.el-button--small,
.el-button--small.is-round {
  padding: 9px 20px;
}
/* .video-list {
  width: 75%;
} */
.video-list .carousel-img-outer {

}
.video-list .carousel-img-outer img {
  width: 100%;
}
.forum-title {
  font-size: 16px;
  line-height: 50px;
  color: #333333;
}
/* 字母没选中 */
.ZM {
  background-color: #f8f8f8;
  margin-bottom: 10px;
  padding: 6px;
}
/* 字母选中 */
.ZM-selected {
  background-color: #fff4f2;
  border: solid 1px #f64420;
  color: #f64420;
  margin-bottom: 10px;
  padding: 6px;
}
/* 字母悬停 */
.ZM:hover {
  color: white;
  border: 1px solid #f64420;
  background-color: #f64420;
}
.zcy {
  padding-left: 0px;
}
</style>
<style>
.top-carousel-medicine .el-carousel__indicators--horizontal {
  bottom: 10px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  width: 100%;
  text-align: center;
}
/* .top-carousel-box .el-carousel__container {
  position: relative;
  height: 300px;
} */
.top-carousel.top-carousel-medicine .el-carousel__container {
  height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HerbalMedicineIndex.vue